var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.77,33.53C7.52,33.53,0,26.01,0,16.77S7.52,0,16.77,0c4.58,0,8.86,1.81,12.05,5.11l-2.19,2.12c-2.61-2.7-6.11-4.18-9.86-4.18-7.56,0-13.72,6.15-13.72,13.72s6.15,13.72,13.72,13.72,13.72-6.15,13.72-13.72c0-.73-.06-1.47-.17-2.19l3.01-.48c.14,.88,.21,1.78,.21,2.67,0,9.24-7.52,16.77-16.77,16.77Z","fill":"#1c75ba","key":0}),React.createElement("path",{"d":"M15.76,26.06L5.41,15.72l1.99-1.99,8.36,8.36L33.49,4.36l1.99,1.99L15.76,26.06Z","fill":"#ef7021","key":1})]);
}

Checkmark.defaultProps = {"viewBox":"0 0 35.48 33.53"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
